import React, { useEffect, useRef, useState } from "react";
import "./styles.scss";
import { Button, Col, Drawer, Form, Input, Row, Select, Slider, Tooltip } from "antd";
import {
  BUYER_STATES_FILTERS,
  ENTERPRISE_ROLE,
  INVESTOR_TYPES_FILTERS,
  primarySectorOptions,
  privateEquityTypeFields,
  recordActions,
  ventureTypeFields,
} from "../../../../../../constant";
import { SearchOutlined, Tune } from "@mui/icons-material";
import { BeatLoader } from "react-spinners";
import { InvestorsPDF } from "../../../../../../helpers/pdfGenerator";
import { investorListMauplator } from "../../../../../../helpers/manuplator";
import { pdf } from "@react-pdf/renderer";
import { saveAs } from "file-saver";
import { CSVLink } from "react-csv";
import { useSelector } from "react-redux";
import {
  broad_specialty_defs,
  narrow_specialty_defs,
} from "../../../../../../constant/specialty";
import { TagsInput } from "react-tag-input-component";
import { naicsSectors } from "../../../../../../constant/naics-sectors";
import GeneratingPdfModal from "../../../../../../components/generating-pdf-modal";

function SearchBox({
  searchVal,
  setSearchVal,
  selectedFilter,
  setFilters,
  data,
  getInvestorsForPDF,
  searchAccess,
  setAdvancedSearch,
  setViewAbleFilters,
  isCrmExportLoding,
  exportInvestorsToCRM,
}) {
  // STATES
  const [filterPreview, setFilterPreview] = useState(false);
  const [isPdfLoading, setPdfLoading] = useState(false);
  const [pdfModalVisible, setPdfModalVisible] = useState(false);
  const [pdfProgress, setPdfProgress] = useState(0);
  const [isCsvLoading, setCsvLoading] = useState(false);
  const [selectedInvestors, setselectedInvestors] = useState([]);
  const [selectedType, setSelectedType] = useState([]);
  const [broadOptions, setbroadOptions] = useState([]);
  const [narrowOptions, setnarrowOptions] = useState([]);
  const [selectedKeywords, setSelectedKeywords] = useState([]);

  // REDUX DATA
  const user = useSelector((state) => state.UserReducer.profile);

  // CONST VALS
  const { http } = global.services;
  const isEnterpriseUser = user?.role === ENTERPRISE_ROLE;
  const downloadCsvBtn = useRef(null);
  const [form] = Form.useForm();
  const isBtnDisabled = data?.length < 1;
  const marks = {
    0: "1",
    100: "1000",
  };
  const typeFilters = [
    {
      label: "All Records",
      value: "default",
    },
    {
      label: "Companies",
      value: "companies",
    },
    {
      label: "Investors",
      value: "investors",
    },
  ];

  const CSV_HEADERS = [
    { label: "Name", key: "name" },
    { label: "URL", key: "website" },
    { label: "Description", key: "description" },
    { label: "Type", key: "type" },
    {
      label: "NAICS Industry",
      key: "naics_six_digit_industry",
    },
    { label: "State", key: "state" },
    { label: "Country", key: "country" },
    { label: "Broad Specialty", key: "broad_specialty" },
    { label: "Narrow Specialty", key: "narrow_specialty" },
    {
      label: "Preferred Ebitda (mm)",
      key: "preferred_ebitda",
    },
    {
      label: "Preferred Revenue (mm)",
      key: "preferred_revenue",
    },
    { label: "Preferred EV (mm)", key: "preferred_ev" },
    {
      label: "Equity Investment (mm)",
      key: "typical_equity_investments",
    },
  ];

  // HANDLERS
  const sliderFormatter = (value) => (value === 0 ? 1 : value * 10);

  const primarySectorHandler = (value) => {
    const broadOptionsList = [];

    if (Array.isArray(value) && value.length > 0) {
      value.forEach((key) => {
        const defs = broad_specialty_defs[key];
        if (Array.isArray(defs)) {
          broadOptionsList.push({ label: key, value: key, indicator: true });
          defs.forEach((item) => {
            broadOptionsList.push({ label: item, value: item });
          });
        }
      });
    }

    setbroadOptions(broadOptionsList);

    // Sync selected broad specialties
    const broadSelectedValue = form.getFieldValue("broad_specialty") || [];

    const broadSelectedOptions = broadSelectedValue
      .map((item) => broadOptionsList.find((option) => option.value === item))
      .filter(Boolean);

    const newBroadOptions =
      broadSelectedOptions.length > 0
        ? broadSelectedOptions.map((item) => item.value)
        : undefined;

    form.setFieldsValue({
      broad_specialty: newBroadOptions,
    });

    // Reset narrow specialties when primary sector changes
    broadSpecialityHandler(newBroadOptions);
  };

  const broadSpecialityHandler = (broadOptions) => {
    const narrowOptionsList = [];

    if (Array.isArray(broadOptions) && broadOptions.length > 0) {
      broadOptions.forEach((option) => {
        const defs = narrow_specialty_defs[option];
        if (Array.isArray(defs)) {
          narrowOptionsList.push({ label: option, value: option, indicator: true });
          defs.forEach((item) => {
            narrowOptionsList.push({ label: item, value: item });
          });
        }
      });
    }

    setnarrowOptions(narrowOptionsList);

    // Sync selected narrow specialties
    const narrowSelectedValue = form.getFieldValue("narrow_specialty") || [];

    const narrowSelectedOptions = narrowSelectedValue
      .map((item) => narrowOptionsList.find((option) => option.value === item))
      .filter(Boolean);

    form.setFieldsValue({
      narrow_specialty:
        narrowSelectedOptions.length > 0
          ? narrowSelectedOptions.map((item) => item.value)
          : undefined,
    });
  };

  const clearHandler = () => {
    setSearchVal("");
    setFilters({});
    setViewAbleFilters({});
    form.resetFields();
    setSelectedType([]);
    setFilterPreview(false);
  };

  const exportToCRM = async (event) => {
    event.preventDefault();
    exportInvestorsToCRM();
  };

  const downloadPDF = async (event) => {
    event.preventDefault();
    setPdfLoading(true);
    setPdfProgress(0);
    setPdfModalVisible(true);
    const progressInterval = setInterval(() => {
      setPdfProgress((prev) => {
        if (prev >= 90) {
          clearInterval(progressInterval);
          return prev;
        }
        return prev + 8;
      });
    }, 120);
    try {
      const investors = await getInvestorsForPDF();
      const blob = await pdf(<InvestorsPDF data={investors} />).toBlob();
      clearInterval(progressInterval);
      setPdfProgress(100);
      http.post("action-record", {
        action: recordActions.investorPDF,
      });
      setPdfModalVisible(false);
      saveAs(blob, "investors.pdf");
    } catch {
      clearInterval(progressInterval);
      setPdfModalVisible(false);
    } finally {
      setPdfLoading(false);
    }
  };

  const downloadCsv = () => {
    setCsvLoading(true);
    getInvestorsForPDF().then((data) => {
      setselectedInvestors(investorListMauplator(data));
      setCsvLoading(false);
      http.post("action-record", {
        action: recordActions.investorCSV,
      });
      downloadCsvBtn?.current?.link.click();
    });
  };

  const setSearchValHandler = (value) => {
    setSearchVal(value);
    if (value === "" && selectedFilter?.description)
      setFilters((prev) => ({
        ...prev,
        description: undefined,
      }));
  };

  const searchHandler = () => {
    setAdvancedSearch(true);
    setFilters((prev) => ({
      ...prev,
      description: searchVal,
    }));
  };

  const selectTypeFilterHandler = (value) => {
    const filter = { ...selectedFilter };
    filter.type_filter = value;
    setFilters(filter);
  };

  const setKeywordsHandler = (keywords) => {
    setSelectedKeywords(keywords);
  };

  const submitHandler = (newfilters) => {
    const filters = {
      ...newfilters,
      keywords: selectedKeywords,
      type_filter: selectedFilter.type_filter,
    };
    const viewAbleFilters = { ...filters };
    const values = { ...filters };
    Object.keys(viewAbleFilters).forEach((key) => {
      if (viewAbleFilters[key] === undefined || viewAbleFilters[key]?.length === 0)
        delete viewAbleFilters[key];
      if (key === "state") {
        if (!viewAbleFilters[key]) return;
        const statekey = viewAbleFilters[key]
          .map((item) => BUYER_STATES_FILTERS.find((x) => x.value === item)?.label)
          ?.join(", ");
        viewAbleFilters[key] = statekey;
      }
      if (
        key === "preferred_ebitda" ||
        key === "preferred_revenue" ||
        key === "preferred_ev" ||
        key === "typical_equity_investments"
      ) {
        if (typeof viewAbleFilters[key] !== "object") return;
        viewAbleFilters[key] = `${viewAbleFilters[key]
          .map((item) => (item === 0 ? 1 : item))
          .join(" - ")}mm`;
      }
      if (typeof viewAbleFilters[key] === "object") {
        viewAbleFilters[key] = viewAbleFilters[key].join(", ");
      }
    });
    if (selectedType.length === 0) {
      ventureTypeFields.forEach((item) => {
        if (values[item]) {
          delete viewAbleFilters[item];
          delete values[item];
        }
      });
      privateEquityTypeFields.forEach((item) => {
        if (values[item]) {
          delete viewAbleFilters[item];
          delete values[item];
        }
      });
    }
    if (
      !selectedType.includes(INVESTOR_TYPES_FILTERS[0].value) &&
      !selectedType.includes(INVESTOR_TYPES_FILTERS[1].value)
    ) {
      ventureTypeFields.forEach((item) => {
        if (values[item]) {
          delete viewAbleFilters[item];
          delete values[item];
        }
      });
    }

    if (!selectedType.includes(INVESTOR_TYPES_FILTERS[2].value)) {
      privateEquityTypeFields.forEach((item) => {
        if (values[item]) {
          delete viewAbleFilters[item];
          delete values[item];
        }
      });
    }
    setViewAbleFilters(viewAbleFilters);
    setAdvancedSearch(true);
    setFilters({ description: searchVal, ...values });
    setFilterPreview(false);
  };

  // HOOKS
  useEffect(() => {
    if (selectedFilter) {
      form.resetFields();
      setKeywordsHandler(selectedFilter.keywords ?? []);
      if (selectedFilter.super_sector) {
        primarySectorHandler(selectedFilter.super_sector);
      }
      if (selectedFilter.broad_specialty) {
        broadSpecialityHandler(selectedFilter.broad_specialty);
      }
      form.setFieldsValue(selectedFilter);
      if (selectedFilter?.type && selectedFilter?.type.length > 0) {
        setSelectedType(selectedFilter?.type);
      } else {
        setSelectedType([]);
      }
    }
  }, [selectedFilter]);
  return (
    <>
      <ul className="filters-box">
        {typeFilters.map((item, index) => (
          <li
            key={index}
            className={selectedFilter?.type_filter === item.value ? "active" : ""}
            onClick={() => selectTypeFilterHandler(item.value)}
          >
            {item.label}
          </li>
        ))}
      </ul>
      <div className="top-header">
        <div className={`input-box ${searchAccess ? "" : "disabled"}`}>
          <span className="prefix">
            <SearchOutlined />
          </span>
          {/* <Input
            value={searchVal}
            className="search-box"
            placeholder="Name"
            onChange={(e) => setSearchVal(e.target.value)}
          /> */}
          <Input
            allowClear
            disabled={!searchAccess}
            value={searchVal}
            className="search-box"
            placeholder="Description"
            onChange={(e) => setSearchValHandler(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && searchHandler()}
          />
          <button
            className="apply-button"
            onClick={searchHandler}
            disabled={!searchAccess || searchVal?.length < 1}
          >
            Search
          </button>
          <div className="suffix">
            <Tooltip title="Filter by keywords, name, sector, specialty, and more">
              <button onClick={() => setFilterPreview(true)}>Advanced Filters</button>
            </Tooltip>
          </div>
        </div>
        <div className="action-box">
          <Button
            className="download-btn large"
            disabled={isBtnDisabled || isPdfLoading}
            onClick={downloadPDF}
          >
            {isPdfLoading ? (
              <BeatLoader className="loader" color="#fff" size={7} />
            ) : (
              "Download PDF"
            )}
          </Button>
          <Button
            className="download-btn large"
            onClick={downloadCsv}
            disabled={isBtnDisabled || isCsvLoading}
          >
            {isCsvLoading ? (
              <BeatLoader className="loader" color="#fff" size={7} />
            ) : (
              "Download CSV"
            )}
          </Button>
          {/* {isEnterpriseUser && (
            <Button
              className="download-btn large"
              disabled={isBtnDisabled || isCrmExportLoding}
              onClick={exportToCRM}
            >
              {isCrmExportLoding ? (
                <BeatLoader className="loader" color="#fff" size={7} />
              ) : (
                "Export to CRM"
              )}
            </Button>
          )} */}
          <div style={{ display: "none" }}>
            <CSVLink
              data={selectedInvestors}
              ref={downloadCsvBtn}
              filename={"investors"}
              headers={CSV_HEADERS}
            />
          </div>
        </div>
      </div>
      <Drawer
        className="investor-filters"
        title="Advance filters"
        open={filterPreview}
        onClose={() => setFilterPreview(false)}
      >
        <Form form={form} onFinish={submitHandler} disabled={!searchAccess}>
          <div className="fields-wrapper">
            <label htmlFor="keywords" style={{ marginTop: 0 }}>
              Keywords
            </label>
            <div
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.stopPropagation(); // stops bubbling
                  e.preventDefault(); // stops form submit
                }
              }}
            >
              <TagsInput
                value={selectedKeywords}
                onChange={setKeywordsHandler}
                name="tags"
                separators={[",", "Enter"]}
                placeHolder='Type and press "Enter"'
                beforeAddValidate={(tag) => {
                  return selectedKeywords.length < 6;
                }}
              />
            </div>
            <label htmlFor="name">Name</label>
            <Form.Item name="name">
              <Input placeholder="Name" />
            </Form.Item>
            {/* <label htmlFor="" style={{ marginTop: 0 }}>
              Description
            </label>
            <Form.Item name="description">
              <Input placeholder="Filter by description" />
            </Form.Item> */}
            <label htmlFor="">State</label>
            <Form.Item name="state">
              <Select
                showSearch
                mode="multiple"
                placeholder="Filter by state"
                options={BUYER_STATES_FILTERS}
                getPopupContainer={(trigger) => trigger.parentNode}
                filterOption={(input, option) =>
                  option.label.toLowerCase().includes(input.toLowerCase())
                }
              >
                {BUYER_STATES_FILTERS.map((state, index) => (
                  <Select.Option key={index} value={state.value}>
                    {state.label}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <label htmlFor="">Sector Focus</label>
            <Form.Item name="sector_focus">
              <Input placeholder="Filter by sector focus" />
            </Form.Item>
            <label htmlFor="">Specialty Focus</label>
            <Form.Item name="specialty_interests">
              <Input placeholder="Filter by specialty focus" />
            </Form.Item>
            <label htmlFor="">Type</label>
            <Form.Item name="type">
              <Select
                showSearch
                mode="multiple"
                placeholder="Filter by type"
                options={INVESTOR_TYPES_FILTERS}
                getPopupContainer={(trigger) => trigger.parentNode}
                onChange={(value) => setSelectedType(value)}
                filterOption={(input, option) =>
                  option.label.toLowerCase().includes(input.toLowerCase())
                }
              >
                {INVESTOR_TYPES_FILTERS.map((state, index) => (
                  <Select.Option key={index} value={state.label}>
                    {state.label}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            {(selectedType.includes(INVESTOR_TYPES_FILTERS[0].value) ||
              selectedType.includes(INVESTOR_TYPES_FILTERS[1].value)) && (
              <>
                <label htmlFor="">NAICS Industry</label>
                <Form.Item name="naics_six_digit_industry">
                  <Select
                    showSearch
                    mode="multiple"
                    placeholder="Filter by NAICS industry"
                    getPopupContainer={(trigger) => trigger.parentNode}
                    filterOption={(input, option) =>
                      option.value.toLowerCase().includes(input.toLowerCase())
                    }
                  >
                    {naicsSectors
                      .filter((x) => x.label.length >= 6)
                      .map((sector, index) => (
                        <Select.Option key={index} value={sector.value}>
                          {sector.value}
                        </Select.Option>
                      ))}
                  </Select>
                </Form.Item>
                <label htmlFor="">Primary Sector</label>
                <Form.Item name="super_sector">
                  <Select
                    showSearch
                    mode="multiple"
                    placeholder="Filter by primary sector"
                    onChange={(value) => primarySectorHandler(value)}
                    getPopupContainer={(trigger) => trigger.parentNode}
                    filterOption={(input, option) =>
                      option.value.toLowerCase().includes(input.toLowerCase())
                    }
                  >
                    {primarySectorOptions.map((state, index) => (
                      <Select.Option key={index} value={state.value}>
                        {state.label}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
                <label htmlFor="">Broad Specialty</label>
                <Form.Item name="broad_specialty">
                  <Select
                    showSearch
                    mode="multiple"
                    placeholder="Filter by broad specialty"
                    onChange={(value) => broadSpecialityHandler(value)}
                    getPopupContainer={(trigger) => trigger.parentNode}
                    filterOption={(input, option) =>
                      option.value.toLowerCase().includes(input.toLowerCase())
                    }
                  >
                    {broadOptions.map((state, index) => (
                      <Select.Option
                        key={index}
                        value={state.value}
                        disabled={state.indicator}
                        className={state.indicator ? "select-option-indicator" : ""}
                      >
                        {state.label}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
                <label htmlFor="">Narrow Specialty</label>
                <Form.Item name="narrow_specialty">
                  <Select
                    showSearch
                    mode="multiple"
                    placeholder="Filter by narrow specialty"
                    getPopupContainer={(trigger) => trigger.parentNode}
                    filterOption={(input, option) =>
                      option.value.toLowerCase().includes(input.toLowerCase())
                    }
                  >
                    {narrowOptions.map((state, index) => (
                      <Select.Option
                        key={index}
                        value={state.value}
                        disabled={state.indicator}
                        className={state.indicator ? "select-option-indicator" : ""}
                      >
                        {state.label}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </>
            )}
            {selectedType.includes(INVESTOR_TYPES_FILTERS[2].value) && (
              <>
                <label>
                  Preferred Ebitda<i> (mm)</i>
                </label>
                <div className="slider-box">
                  <Form.Item name="preferred_ebitda">
                    <Slider
                      range
                      marks={marks}
                      tooltip={{
                        formatter: sliderFormatter,
                      }}
                    />
                  </Form.Item>
                </div>
                <label>
                  Preferred Revenue<i> (mm)</i>
                </label>
                <div className="slider-box">
                  <Form.Item name="preferred_revenue">
                    <Slider
                      range
                      marks={marks}
                      tooltip={{
                        formatter: sliderFormatter,
                      }}
                    />
                  </Form.Item>
                </div>
                <label>
                  Preferred EV<i> (mm)</i>
                </label>
                <div className="slider-box">
                  <Form.Item name="preferred_ev">
                    <Slider
                      range
                      marks={marks}
                      tooltip={{
                        formatter: sliderFormatter,
                      }}
                    />
                  </Form.Item>
                </div>
                <label>
                  Typical Equity Investments<i> (mm)</i>
                </label>
                <div className="slider-box">
                  <Form.Item name="typical_equity_investments">
                    <Slider
                      range
                      marks={marks}
                      tooltip={{
                        formatter: sliderFormatter,
                      }}
                    />
                  </Form.Item>
                </div>
              </>
            )}
          </div>
          <div className="action-box">
            <span className="action-btn clear" onClick={clearHandler}>
              Clear
            </span>
            <button className="action-btn submit" disabled={!searchAccess}>
              Apply
            </button>
          </div>
        </Form>
      </Drawer>
      <GeneratingPdfModal
        visible={pdfModalVisible}
        onClose={() => setPdfModalVisible(false)}
        progress={pdfProgress}
      />
    </>
  );
}

export default SearchBox;
